module.exports = __webpack_public_path__ + "assets/img/fcbmy-a.082ce79e.png";